import React, { useEffect, useState } from "react";
import arrowRight from "../../assets/Icons/arrow-right-black.svg";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { useDispatch, useSelector } from "react-redux";
import { message } from "../../redux/actions/toastActions";
import ModalPopup from "../common/Modal";
import crossIcon from "../../assets/Icons/cross.svg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { admissionGuidelinesSchema } from "../../helpers/validations";
import DeleteModal from "../common/DeleteModal";
import { isPermission, isRole } from "../../redux/selectors/authSelector";

function AdmissionGuidelines() {
  const dispatch = useDispatch();
  const [Data, setData] = useState([]);
  const [isLoading, setIsloading] = useState(true);
  const [refresh, setRefresh] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [modalswitch, setmodalswitch] = useState(false);
  const [modalOpenDelete, setmodalOpenDelete] = useState(false);
  const [modalOpenDetails, setmodalOpenDetails] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [modalDetailsData, setModalDetailsData] = useState(null);
  const [apiloader, setapiloader] = useState(false);
  const [formInitialValues, setFormInitialValues] = useState({
    title: "",
    description: "",
  });
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
  const [Type, setType] = useState("");


  const permissions = useSelector(isPermission);
  const role = useSelector(isRole)
  console.log("permissions", permissions)
  const addPermission = role == "schooladmin" || permissions && permissions?.includes('edit_Admissions') || false;
  const deletePermission = role == "schooladmin" || permissions && permissions?.includes('delete_Admissions') || false;

  console.log(selectedId, "selectedId");

  const admissionGuidelinesData = () => {
    setIsloading(true);
    Postdata(HttpService.admission_guidelines_list, {
      // page: currentPage,
      // perpage: perPage,
      //   board_member_id: boardMemberId,
      //   startDate: startDate,
      //   endDate: endDate,
    })
      .then((response) => {
        if (response.status === 200) {
          setData(response.data.guidelines);
          setTotalRows(response.data.count);
          setIsloading(false);
        } else {
          setIsloading(false);
          dispatch(message(response.message));
        }
      })
      .catch((e) => {
        setIsloading(false);
        dispatch(message(e.message));
      });
  };

  useEffect(() => {
    admissionGuidelinesData();
  }, [refresh]);

  const handleAddAdmissionGuideline = (
    values,
    setSubmitting,
    resetForm,
    setmodalswitch,
    setRefresh,
    dispatch
  ) => {
    const payload = {
      ...values,
      ...(selectedId ? { id: selectedId } : {}), // Only include `id` when editing
    };
    Postdata(HttpService.admission_guidelines_add, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(message("Guideline added successfully"));
          setmodalswitch(false);
          setRefresh((prev) => !prev);
          resetForm();
          setSelectedId(null);
        } else {
          dispatch(message(response.message));
        }
        setSubmitting(false);
      })
      .catch((error) => {
        dispatch(message(error.message));
        setSubmitting(false);
      });
  };

  const fetchData = async (id) => {
    setapiloader(true);
    const response = await Postdata(HttpService.admission_guidelines_show, {
      id: id,
    });
    if (response.status !== 200) {
      dispatch(message(response.message));
      setapiloader(false);
      return;
    }
    setModalDetailsData(response.data); // Save data to show in modal
    setapiloader(false);
  };

  const handleDelete = (id) => {
    if (!id) return;

    setmodalOpenDelete(false);
    setmodalOpenDetails(false);
    setIsloading(true);

    Postdata(HttpService.admission_guidelines_delete, { id })
      .then((res) => {
        dispatch(message(res.message));
        setmodalOpenDetails(false);
        setRefresh((prev) => !prev);
      })
      .catch((error) => {
        console.error("Delete failed:", error);
        dispatch(message("Failed to delete. Please try again."));
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  return (
    <>
      <div className="flex justify-between items-center">
        <span className="label-subtitle">Admission Guidelines </span>
        {addPermission && <button
          className="button-small-primary"
          onClick={() => {
            setSelectedId(null);
            setFormInitialValues({ title: "", description: "" });
            setmodalswitch(true);
            setType("Add")
          }}
        >
          + Add
        </button>}
      </div>
     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
        {isLoading ? (
          <div className="w-full col-span-3 flex justify-center items-center">
            Loading...
          </div>
        ) : (
          Data?.map((section, index) => (
            <div
              key={index}
              onClick={() => {
                setmodalOpenDetails(true);
                fetchData(section._id);
              }}
              className="flex justify-between items-center bg-white rounded-xl p-[15px] hover:shadow-md transition-shadow cursor-pointer"
            >
              <span className="label-body-base font-medium text-gray-800 overflow-hidden overflow-ellipsis whitespace-nowrap">
                {section?.title}
              </span>
              <img src={arrowRight} className="text-gray-500" />
            </div>
          ))
        )}
      </div>


      <ModalPopup
        className="alert-box-popup"
        show={modalOpenDetails}
        size="md"
        onHide={() => setmodalOpenDetails(false)}
        heading="Are you sure?"
      >
        <div className="text-start flex justify-center flex-col items-center gap-3 px-3 relative ">
          <img
            src={crossIcon}
            alt=""
            className="absolute top-2 right-2 cursor-pointer"
            onClick={() => {
              setmodalOpenDetails(false);
            }}
          />

         {apiloader ? (
            <p>Loading...</p>
          ) : modalDetailsData ? (
            <div className="w-full text-left">
              <h3 className={`text-lg font-semibold mb-3 px-4 text-center whitespace-pre-wrap ${
                  modalDetailsData.title.length > 35 ? "break-words" : ""
                }`}>
                {modalDetailsData.title}
              </h3>
              <p
                className={`label-body-base whitespace-pre-wrap ${
                  modalDetailsData.description.length > 55 ? "break-words" : ""
                }`}
              >
                {modalDetailsData.description}
              </p>
            </div>
          ) : (
            <p>No data found.</p>
          )}

         <div className="w-full flex justify-between gap-3 mb-2">
            {deletePermission && (
              <button
                className="bg-secondary_main w-full text-white px-4 py-2 rounded-lg whitespace-nowrap"
                onClick={() => {
                  setmodalOpenDelete(true);
                  setSelectedId(modalDetailsData._id);
                }}
              >
                Delete
              </button>
            )}
            {addPermission && (
              <button
                className="button-field-primary w-full text-white px-4 py-2 rounded-lg whitespace-nowrap"
                onClick={() => {
                  setmodalswitch(true);
                  setFormInitialValues({
                    title: modalDetailsData?.title || "",
                    description: modalDetailsData?.description || "",
                  });
                  setmodalOpenDetails(false); // Close details modal
                  setSelectedId(modalDetailsData._id); // or whatever the ID field is
                  setType("Edit");
                }}
              >
                Edit
              </button>
            )}
          </div>
        </div>
      </ModalPopup>

      <ModalPopup
        className="alert-box-popup"
        show={modalswitch}
        size="md"
        onHide={() => setmodalswitch(false)}
        heading="Are you sure?"
      >
        <div className="text-start flex justify-center flex-col items-center gap-3 px-3 relative ">
          <img
            src={crossIcon}
            alt=""
            className="absolute top-2 right-2 cursor-pointer"
            onClick={() => {
              setmodalswitch(false);
            }}
          />
          <h3> {Type} Admission Guidelines</h3>
          <Formik
            initialValues={formInitialValues}
            enableReinitialize
            validationSchema={admissionGuidelinesSchema}
            onSubmit={(values, { setSubmitting, resetForm }) =>
              handleAddAdmissionGuideline(
                values,
                setSubmitting,
                resetForm,
                setmodalswitch,
                setRefresh,
                dispatch
              )
            }
          >
            {({ isSubmitting }) => (
              <Form className="w-full">
                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    Title <span className="text-red-500">*</span>
                  </label>
                  <Field
                    type="text"
                    name="title"
                    placeholder="Enter Title"
                    className="input-field-grey"
                    maxLength="50" 
                  />
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="text-red-500 "
                  />
                </div>

                <div className="mt-2">
                  <label className="block mb-1 font-medium text-gray-700">
                    Description <span className="text-red-500">*</span>
                  </label>
                  <Field
                    as="textarea"
                    name="description"
                    placeholder="Write here"
                    className="input-field-grey"
                    maxLength="400" 
                  />
                  <ErrorMessage
                    name="description"
                    component="div"
                    className="text-red-500"
                  />
                </div>

                <div className="w-full flex justify-between gap-3 mb-2 mt-4">
                  <button
                    type="submit"
                    className="button-field-primary"
                    style={{ width: "100%" }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Saving..." : "Save"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </ModalPopup>

      <DeleteModal
        title="Delete Admission Guideline"
        message="Are you sure you want to delete admission guideline? It will erase all the data permanently."
        modalOpenDelete={modalOpenDelete}
        setmodalOpenDelete={setmodalOpenDelete}
        handleDelete={handleDelete} // Don't call it here
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        modalOpenDeleteSuccess={modalOpenDeleteSuccess}
        setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
        module={"Admission Guideline"}
        redirectPage={"Admissions"}
        redirectUrl={'/admissions'}
      />
      {
        !isLoading && Data.length === 0 && <div className="h-[50vh] flex items-center justify-center w-full">
          <h1 className="text-center text-gray-400">No Data Found</h1>
        </div>
      }
    </>
  );
}

export default AdmissionGuidelines;
